import api from 'Application/api/api';

const deleteEpcInquiry = (signal, inquiryId) =>
	api.delete(`/inquiries/partner/${inquiryId}`, {
		signal,
	});

export default deleteEpcInquiry;
